import React, { useEffect, useState, useCallback } from "react";
import Review from "./review";
import Loader from "../loader";

const ReviewList = ({circleId, currentUser, isFormShow, digestPage = false, isCircleManager = false}) => {
  const [circlesReviews, setCirclesReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadReviews = useCallback(() => {
    $.ajax({
      url: "/api/circles_reviews",
      type: "GET",
      cache: false,
      data: {
        circle_id: circleId,
      },
    })
      .then((data) => {
          setCirclesReviews(digestPage ? data.circles_reviews.slice(0, 2) : data.circles_reviews);
          setLoading(false);
        },
      )
      .fail(() => {
          setLoading(false)
        },
      );
  }, []);

  useEffect(() => {
    loadReviews();
  }, [loadReviews]);

  const circlesReviewsList = circlesReviews.map((review) => {
    return (
      <div key={review.id}>
        {(review && (
          <Review
            review={review}
            currentUser={currentUser}
            isFormShow={isFormShow}
            isCircleManager={isCircleManager}
          />
        ))}
      </div>
    );
  });

  return (
    <div className="pl-2">
      <div id="comment-area">
        <div className="pt-3 pb-0">
          <ul className="list-unstyled mb-0">{circlesReviewsList}</ul>
        </div>
        <Loader isActive={loading} />
      </div>
    </div>
  );
};


export default ReviewList;
